// Package imports:
import React from 'react';
// Component imports:
import NewPasswordForm from './NewPasswordForm';
import Link from '../../ui-elements/Link/Link';

const NewPassword: React.FC = () => {

    return (
        <div className='main KCL_new_password-page'>
            <div className="section section--primary">
                 <div className="section__body">
                    <div className="shell">
                        <div className="new_password_container">
                            <h2>Nýtt lykilorð</h2>
                            <NewPasswordForm />
                            <p className="note paragraph-small">
                                Athugið að nýtt lykilorð tekur gildi á eftirfarandi kerfum:
                            </p>
                            <div className='keldan__links'>
                                <Link linkSize='16' url="/" target="_blank">Keldan.is</Link>
                                <Link linkSize='16' url="/Keldan-Markadir" target="_blank">Keldan markaðir</Link>
                                <Link linkSize='16' url="https://kodiak.is/kodiak-pro.html" target="_blank">KODIAK Pro</Link>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
        </div>
    )
}

export default NewPassword;